import { Link } from 'react-router-dom';
import { Box, makeStyles } from '@material-ui/core';
import Text from 'components/Text';

const useStyles = makeStyles((theme) => ({
  groupTitle: {
    fontSize: 18,
    lineHeight: '26px',
    fontWeight: 600,
    color: theme.palette.colors.grey600,
    textTransform: 'uppercase',
    marginBottom: theme.spacing(2),

    '& a': {
      color: 'inherit',
    },
  },
  links: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: 24,
    background: theme.palette.colors.grey100,
    flexGrow: 1,
    height: '100%',
    flexShrink: 0,
  },
  link: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    marginRight: 8,
  },
}));

const MenuItem = ({ name, href, to, submenu }) => {
  const classes = useStyles();

  return (
    submenu && (
      <Box className={classes.links}>
        {submenu.map(({ Icon, ...item }) => (
          <Link key={item.id} to={item.href} className={classes.link}>
            {Icon && <Icon className={classes.icon} fontSize={32} />}
            <Text variant="caption3" color="colors.grey800">
              {item.title}
            </Text>
          </Link>
        ))}
      </Box>
    )
  );
};

export default MenuItem;
